import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import Button from '../Button/Button';
import './navbar.css'

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);




    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);
    const showButton = () => {
        if(window.innerWidth <= 960){
            setButton(false);
        } else {
            setButton(true);
        }
    }
    

    window.addEventListener('resize', showButton);
    return (
        <>   
    <nav className='navbar'>
        <div className='navbar-container'> 
            <Link to='/' className='navbar-logo'> <i class="fas fa-seedling" />Sarah'sNutrition <img className='picture' alt="pic" src='./images/Logo.jpg' />
            </Link>
        <div className='menu-icon' onClick={handleClick}>
            
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
                <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                    Home
                </Link>
            </li>
            <li className='nav-item'>
                <Link to='/Location' className='nav-links' onClick={closeMobileMenu}>
                    Location
                </Link>
            </li>
            <li className='nav-item'>
                <Link to='/Services' className='nav-links' onClick={closeMobileMenu}>
                Services
                </Link>
            </li>
            <li className='nav-item'>
                <Link to='/Appointment' className='nav-links' onClick={closeMobileMenu}>
                    Schedule appointment
                </Link>
            </li>
        </ul>
        {button && <Button buttonStyle='btn--outline'>Call</Button>}
        </div>
    </nav>
    </>
  )
}

export default Navbar